import { Config } from 'mixpanel-browser';

export const MIXPANEL_TOKEN = import.meta.env.VITE_MIX_PANEL_API_TOKEN;
export const MIXPANEL_CONFIG: Partial<Config> = {
  debug: false,
  persistence: 'localStorage',
  track_pageview: 'full-url',
};
